import { useParams, Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Breadcrumb from '@/components/base/Breadcrumb';
import ArticleCard from '@/components/base/ArticleCard';
import { categories, getArticlesByCategory } from '@/mocks/articles';

export default function Category() {
  const { slug } = useParams<{ slug: string }>();
  const category = categories.find((c) => c.slug === slug);
  const articles = slug ? getArticlesByCategory(slug) : [];

  if (!category) {
    return (
      <>
        <Navbar />
        <div className="pt-24 pb-16 text-center">
          <h2 className="text-xl font-heading font-bold text-foreground-950">分类不存在</h2>
          <Link to="/" className="text-sm text-primary-500 hover:underline mt-4 inline-block">
            返回首页
          </Link>
        </div>
        <Footer />
      </>
    );
  }

  const categorySchema = {
    '@context': 'https://schema.org',
    '@type': 'CollectionPage',
    name: `${category.name} - 黑料吃瓜网`,
    url: `http://baoliao51.cn/category/${slug}`,
    description: category.description,
    isPartOf: {
      '@type': 'WebSite',
      name: '黑料吃瓜网',
      url: 'http://baoliao51.cn/',
    },
  };

  return (
    <>
      <script type="application/ld+json">{JSON.stringify(categorySchema)}</script>

      <Navbar />

      <main className="pt-24 pb-16">
        <div className="px-4 md:px-6 max-w-[1280px] mx-auto">
          <Breadcrumb
            items={[
              { label: '首页', href: '/' },
              { label: category.name },
            ]}
          />

          <header className="mb-8">
            <div className="flex items-center gap-3 mb-2">
              <div className="w-10 h-10 flex items-center justify-center rounded-full bg-primary-100">
                <i className={`${category.icon} text-primary-500 text-lg`}></i>
              </div>
              <h1 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
                {category.name}
              </h1>
            </div>
            <p className="text-sm text-foreground-600">{category.description}</p>
          </header>

          {articles.length > 0 ? (
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
              {articles.map((article) => (
                <ArticleCard key={article.id} article={article} />
              ))}
            </div>
          ) : (
            <div className="text-center py-20">
              <div className="w-16 h-16 mx-auto flex items-center justify-center rounded-full bg-background-100 mb-4">
                <i className="ri-inbox-line text-2xl text-foreground-400"></i>
              </div>
              <p className="text-foreground-500">暂无相关内容</p>
            </div>
          )}
        </div>
      </main>

      <Footer />
    </>
  );
}